import React from 'react';
// No need to import Route or Redirect
import constants from '../constants';

const PublicRoute = ({ component: Component }) => {
  // Simply render the component - no Route wrapper needed
  return <Component />;
};

export default PublicRoute;